import { memo } from "react";
import * as Styled from "./style";
import { PlayButton } from "~/components/blocks/common/play-button";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";

type PlayIconButtonProps = {
  isStreamable: boolean;
  isPlayBtnDisplay: boolean;
  onPlayBtnPressed: () => void;
};

/** VideoSpotLiveSeason の再生アイコンの出し分けに使用する */
export const PlayIconButton = memo((props: PlayIconButtonProps) => {
  const { isStreamable, isPlayBtnDisplay, onPlayBtnPressed } = props;

  const { handleClickByDevice } = useHandleClickByDevice();

  if (isStreamable) {
    return (
      <Styled.DivPlayPositionCenter isPlayBtnDisplay={isPlayBtnDisplay}>
        <PlayButton {...handleClickByDevice(onPlayBtnPressed)} />
        <Styled.ParText>再生</Styled.ParText>
      </Styled.DivPlayPositionCenter>
    );
  }

  return null;
});

PlayIconButton.displayName = "PlayIconButton";
